import { useCallback, useEffect } from 'react';
import { rage } from '~/rage';
import { isRgbPaintType, rgbToHex, VehiclePaintType } from '~/shared';
import { CategoryTypes } from '../components/CategoryTab';
import { useLayoutSelector } from '../redux';

export const usePaintPreview = () => {
	const {
		activeCategory,
		activePaintGroup,
		pearlColor,
		indexedColor,
		sectionIndex,
		colorPickerSelectedColor,
		rimsColor,
	} = useLayoutSelector((state) => ({
		activeCategory: state.carPaint.activeCategory,
		activePaintGroup: state.colorPicker.paintGroup,
		pearlColor: state.colorPicker.pearlColor,
		indexedColor: state.colorPicker.indexedColor,
		sectionIndex: state.colorPicker.sectionIndex,
		colorPickerSelectedColor: state.colorPicker.selectedColor,
		rimsColor: state.colorPicker.rimsColor,
	}));

	const previewBodyColor = useCallback(() => {
		const currentPaintType = activePaintGroup?.type || VehiclePaintType.Classic;
		const hasPearlColor =
			currentPaintType === VehiclePaintType.Pearl &&
			typeof pearlColor === 'number';

		const colorValue = !isRgbPaintType(currentPaintType)
			? indexedColor
			: rgbToHex(colorPickerSelectedColor || { r: 255, g: 255, b: 255 });

		if (sectionIndex === 0) {
			rage.vehiclePaintShop.previewBodyColor(
				colorValue,
				currentPaintType,
				hasPearlColor ? pearlColor : null,
			);
		} else {
			rage.vehiclePaintShop.previewInteriorColor(
				rgbToHex(colorPickerSelectedColor || { r: 255, g: 255, b: 255 }),
			);
		}
	}, [
		sectionIndex,
		colorPickerSelectedColor,
		activePaintGroup,
		indexedColor,
		pearlColor,
	]);

	const previewRimsColor = useCallback(() => {
		rage.vehiclePaintShop.previewRimsColor(rimsColor);
	}, [rimsColor]);

	useEffect(() => {
		const isPaintingWorks = activeCategory === CategoryTypes.PaintingWorks;
		const isPaintingWheels = activeCategory === CategoryTypes.PaintingWheels;

		if (isPaintingWorks) {
			previewBodyColor();
		}

		if (isPaintingWheels && rimsColor) {
			previewRimsColor();
		}
	}, [activeCategory, previewBodyColor, rimsColor, previewRimsColor]);
};
